/**
 * Aspid / contact: форма обращения -> /ajax/contact/send.
 */
const { api, t } = window.rt;

const form = document.querySelector('[data-contact-form]');

if( form ) {

    form.addEventListener( 'submit', async ( event ) => {

        event.preventDefault();

        if( form.dataset.sending === '1' || ! form.reportValidity() )
            return;

        form.dataset.sending = '1';

        const button  = form.querySelector('button[type="submit"]');
        const msgEl   = form.querySelector('[data-form-message]');
        const values  = Object.fromEntries( new FormData( form ).entries() );
        const message = values.phone ? values.message + '\n\n' + t('common.phone') + ': ' + values.phone : values.message;

        button.disabled = true;

        try {

            await api.post( 'contact/send', { name: values.name, email: values.email, message, website: values.website || '' } );

            msgEl.textContent = t('contacts.sent');
            msgEl.className   = 'acc-message is-success';
            msgEl.hidden      = false;

            form.reset();

        } catch( e ) {

            msgEl.textContent = e.message;
            msgEl.className   = 'acc-message is-error';
            msgEl.hidden      = false;
        }

        button.disabled = false;
        delete form.dataset.sending;
    } );
}
